import { render, staticRenderFns } from "./ViewEvaluation.vue?vue&type=template&id=2d1de1ec&"
import script from "./ViewEvaluation.vue?vue&type=script&lang=ts&"
export * from "./ViewEvaluation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports